// extracted by mini-css-extract-plugin
export var card = "_qc-0";
export var content = "_qc-2";
export var details = "_qc-3";
export var icon = "_qc-1";
export var iconBlue = "_qc-5";
export var iconBrand = "_qc-4";
export var iconGrayBlue = "_qc-6";
export var iconGreen = "_qc-7";
export var iconIndigo = "_qc-8";
export var iconOrange = "_qc-9";
export var iconPurple = "_qc-a";
export var iconRed = "_qc-b";
export var iconWarning = "_qc-c";